import { environment } from '../../../environments/environment';

const cloudflareConfig = {
    turnstile: {
        Site_Key: environment.cloudflare.turnstile_site_key,
        Secret_Key: environment.cloudflare.turnstile_secret_key,
    }
};

export default cloudflareConfig;